import { render } from "./Footerbar.vue?vue&type=template&id=14b63750"
const script = {}

import exportComponent from "/Users/dushichen/dev/lowoo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__